export default "__VITE_ASSET__CeUjLmX0__"